export default "__VITE_ASSET__s1TF0bUR__"